// removed by extract-text-webpack-plugin
module.exports = {"orderForm":"OrderForm__orderForm__1iekc","radioButtons":"OrderForm__radioButtons__QA_zG","orderArea":"OrderForm__orderArea__GLzgr","quantityPrice":"OrderForm__quantityPrice__lbNma"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OrderForm/OrderForm.css
// module id = 112
// module chunks = 0